/**
 * File: supervisorViewController.js
 * Project: educore
 * Created Date: 2020-09-11
 * Author: varunsj
 * -----
 * Last Modified: 2020-09-11
 * Modified By: varunsj
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class supervisorViewController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdDialog, $stateParams, localStorageService, authService, profileCons) {
        let self = this;
        let selectedUserId = $stateParams.person_id
        let addedSessionsID = [];
        $scope.showSessionName = [];
        $scope.showCurriculumName = [];
        $scope.userMgt = {}
        console.log('tttttttttttttttttttttttt')
        $scope.firstLoad = true //flag to check the page is loaded first or not

        let module_privileges = localStorageService.get("feature_privileges")


        $scope.userAccess = {}
        let features = module_privileges
        let userAccessJson = _.filter(features, function(feature) {
            return feature.module_state == "userEndorsement";
        });
        if (userAccessJson) {
            _.each(userAccessJson, function(feature) {
                let user_access = {};
                _.each(feature.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userAccess = user_access;
            })
        } else {
            $state.go("dashboard")
        }

        self.myStudents = [];
        if (!selectedUserId) {
            $state.go('profileSetting');
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Gte endorsed sections
         **/
        let hosEndorsedDept = () => {
            $scope.roleSupervisor = true;
            authService.callAPI(profileCons.API_HOS_ENDORSE_DETAILS + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.sections) {
                    $scope.hosPersonArr = response.result.data.sections
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Load session list
         **/
        let sessionDet = () => {
            authService.callAPI(profileCons.API_GET_SESSION + localStorageService.get('school_id'), "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.sessionLst = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Load curriculum list
         **/
        let curriculumDet = (session_id) => {
            authService.callAPI(profileCons.API_GET_CURRICULUM + localStorageService.get('school_id') + "/" + session_id, "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.curriculumLst = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Load class list
         **/
        let classDet = (curriculum_id) => {
            authService.callAPI(profileCons.API_GET_CLASS + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + curriculum_id, "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.clsLst = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Update section(class)
         **/
        let updateSection = (academic_obj, user_id) => {

            let obj = {
                curriculum_id: academic_obj.curriculum_id,
                session_id: academic_obj.session_id,
                school_id: localStorageService.get('school_id'),
                classes: academic_obj.classes,
                id: user_id,
                is_supervisor : true
            }

            authService.callAPI(profileCons.API_UPDATE_SECTION, "POST", obj, (response) => {
                if (response.result && response.result.status && response.result.status.code == 200) {
                    toastr.success("Updated successfully!")
                }

                $scope.firstLoad = false
                $scope.userMgt = {};
                hosEndorsedDept()
                $scope.showAddBtn = false;
                $scope.curriculumLst = [];
                $scope.clsLst = [];
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: To remove section
         **/
        let removeSection = (user_id, academic_obj) => {
            let obj = {
                curriculum_id: academic_obj.curriculum_id,
                session_id: academic_obj.session_id,
                class_id: academic_obj.class_id,
                id: user_id
            }
            authService.callAPI(profileCons.API_DELETE_SECTION, "POST", obj, (response) => {
                if (response.result && response.result.status && response.result.status.code == 200) {
                    hosEndorsedDept()
                    toastr.success("Deleted successfully!")
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Initialization
         **/
        this.$onInit = () => {
            hosEndorsedDept()
            sessionDet()
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to load curriculum list
         **/
        $scope.getCuriculumLst = (session_id) => {
            curriculumDet(session_id)
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to load class list
         **/
        $scope.getClassLst = (curriculum_id) => {
            classDet(curriculum_id)
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to set visibility of add btn
         **/
        $scope.getData = () => {
            $scope.showAddBtn = true;
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Update section
         **/
        $scope.updateSection = () => {
            $scope.userMgt.school_id = localStorageService.get('school_id')

            if ($scope.userMgt.curriculum_id !== undefined && $scope.userMgt.session_id !== undefined) {
                if ($scope.userMgt.classes && $scope.userMgt.classes.length > 0) {
                    updateSection($scope.userMgt, selectedUserId)
                } else {
                    toastr.error("Please select atleast one class")
                }
            } else {
                if ($scope.userMgt.curriculum_id === undefined && $scope.userMgt.session_id === undefined) {
                    toastr.error("Please select all necessary fields")
                } else {
                    if ($scope.userMgt.curriculum_id === undefined) {
                        toastr.error("Please select curriculum")
                    }
                    if ($scope.userMgt.session_id === undefined) {
                        toastr.error("Please select session")
                    }
                }
            }
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to conform delete section
         **/
        $scope.deleteClass = (event, section) => {
            var confirm = $mdDialog.confirm()
                .title('')
                .textContent('Are you sure to remove ?')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {
                removeSection(selectedUserId, section)
            }, function() {});
        }

    }
}

export default supervisorViewController;


// WEBPACK FOOTER //
// ./src/app/profileSetting/controllers/supervisorViewController.js